import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Component({
    selector: 'app-detalhes-erros-cnpj',
    templateUrl: './detalhes-erros-cnpj.component.html',
    styleUrls: ['./detalhes-erros-cnpj.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CurrencyPipe]
})
export class DetalhesErrosCnpjComponent {

  @Input() alertDetalheErrosPedido: any = false;
  @Output() abrirDetalheErrosPedido = new EventEmitter();
  @Input() detalhesErroCnpj: any;

  constructor() {
  }

  fecharDetalhesBeneficio() {
    this.abrirDetalheErrosPedido.emit(false);
    this.alertDetalheErrosPedido = false;
  }
}
